import { Button, Modal, ModalBody } from 'react-bootstrap';
import { BiTimer } from 'react-icons/bi';
import { useSelector } from 'react-redux';

export default function TransactionExpiredModal({ show = false }) {

  const { isShowTransactionExpiredModal, cancelUrl } = useSelector(state => state.main);

  let _cancelUrl = cancelUrl || localStorage.getItem("cancelUrl") || null;

  const redirectToCancelUrl = () => {
    if (!_cancelUrl) {
      return false;
    }
    localStorage.clear();
    window.location.href = _cancelUrl;
  }

  return (
    <Modal show={show || isShowTransactionExpiredModal} onHide={redirectToCancelUrl} centered>
      <ModalBody>
        <div className="cx-modal-container">
          <div className="cx-modal-wrapper">
            <div className="cx-modal-body-container">
              <div className="cx-modal-body-wrapper txPart">
                <p><strong className="cx-d-block">Transaction expired</strong></p>
                <div className="mb-2">
                  <BiTimer color="#0533B3" size={60} />
                </div>
                {/* {
                  _cancelUrl ?
                    <Button className='px-3' variant="secondary" onClick={redirectToCancelUrl}>Ok</Button>
                    : null
                } */}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}
